import styled from "styled-components";

export const Main = styled.main`
  padding: 0px;
  margin: 0px;
  width: 100vw;
  height: 100vh;

  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;

  background-color: var(--primary);
  color: var(--font);
`;
